import { render, staticRenderFns } from "./LikeComponent.vue?vue&type=template&id=0040fd8b&scoped=true&"
import script from "./LikeComponent.vue?vue&type=script&lang=js&"
export * from "./LikeComponent.vue?vue&type=script&lang=js&"
import style0 from "./LikeComponent.vue?vue&type=style&index=0&id=0040fd8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040fd8b",
  null
  
)

export default component.exports